// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--3s5Be","content":"content--1Ac9v contentWrapper--AHarZ","detail":"detail--eGeaM","column":"column--3Hw2s","box":"box--3dkU_","button":"button--3KZq- button--CeyL1 calderDark--1bp9m","smallest":"smallest--Pj_Z2","tickets":"tickets--3efMD","verticalText":"verticalText--3eIph","latestNews":"latestNews--xBd4v","speak":"speak--2V4OK","sponsors":"sponsors--rPFFL","heading":"heading--3yR42","slider":"slider--Dt-sd","training":"training--2BuZQ","newsList":"newsList--Otxto","footer":"footer--3OwwQ"};


//////////////////
// WEBPACK FOOTER
// ./screens/Home/styles.css
// module id = 523
// module chunks = 2